import { ImageEffectsApiModel } from '../../../api/pagebuilder/models/image-effects-api.model';
import { BriefingImageFrameEnum } from '../../../Monitor/Shared/enums/briefing-image-frame.enum';

export class BriefingImageEffectsModel {
    imageFrame?: BriefingImageFrameEnum;
    primaryColor?: string;
    // backgroundColor?: string; // not being used right now but keep for possible future frames / templates
    transition?: number;

    constructor(apiModel?: ImageEffectsApiModel) {
        if (apiModel) {
            if (apiModel.imageFrame) {
                this.imageFrame = apiModel.imageFrame;
            }
            if (apiModel.primaryColor) {
                this.primaryColor = apiModel.primaryColor;
            }
            // if (apiModel.backgroundColor) {
            //     this.backgroundColor = apiModel.backgroundColor;
            // }
            if (apiModel.transition) {
                this.transition = apiModel.transition;
            }
        } else {
            this.imageFrame = BriefingImageFrameEnum.NO_FRAME;
        }
    }

    toApi(): any {
        const api = {} as ImageEffectsApiModel;
        if (this.imageFrame) {
            api.imageFrame = this.imageFrame;
        }
        if (this.primaryColor) {
            api.primaryColor = this.primaryColor;
        }
        // if (this.backgroundColor) {
        //     api.backgroundColor = this.backgroundColor;
        // }
        if (this.transition) {
            api.transition = this.transition;
        }

        return api;
    }

    clone(): BriefingImageEffectsModel {
        const apiModel = this.toApi();
        const clone = new BriefingImageEffectsModel(apiModel);

        return clone;
    }
}
